<template>
  <el-cascader
    v-model="selectedOptions"
    expand-trigger="hover"
    :options="options"
    :style="{ width: width }"
    clearable
    :placeholder="placeholder"
    @change="handleChange" />
</template>

<script>
import { regionData, CodeToText, TextToCode } from 'element-china-area-data'
export default {
  name: 'FAreaPicker',
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    },
    width: {
      type: String,
      default: '100%'
    },
    placeholder: {
      type: String,
      default: '所在区域'
    }
  },
  data() {
    return {
      options: regionData
    }
  },
  computed: {
    selectedOptions: {
      get() {
        if (this.value.length === 3) {
          const provinceCode = TextToCode[this.value[0]].code
          const cityCode = TextToCode[this.value[0]][this.value[1]].code
          const districtCode = TextToCode[this.value[0]][this.value[1]][this.value[2]].code
          if (provinceCode !== undefined && cityCode !== undefined && districtCode !== undefined) {
            return [provinceCode, cityCode, districtCode]
          }
        }
        return []
      },
      set(val) {
        if (val.length === 3) {
          this.$emit('input', [CodeToText[val[0]], CodeToText[val[1]], CodeToText[val[2]]])
        } else {
          this.$emit('input', [])
        }
      }
    }
  },
  methods: {
    handleChange(val) {
      this.$emit('change', val)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
